// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

Vue.config.productionTip = false

/* eslint-disable no-new */

const Widget = Vue.extend({
  router,
  template: '<App :innerHTML="$el.innerHTML" :styleId="$el.attributes.styleId && $el.attributes.styleId.value" :styleName="$el.attributes.styleName && $el.attributes.styleName.value" :sourceId="$el.attributes.sourceId && $el.attributes.sourceId.value" :autoImport="$el.attributes.autoImport" :in-viewport-once="true" :in-viewport-offset-top="400" />',
  components: { App }
});

var widgetNodes = document.querySelectorAll('.mb-widget');
for (var i = 0; i < widgetNodes.length; ++i) {
  let widgetNode = widgetNodes[i];
  new Widget({ el: widgetNode });
}

router.replace('/');



// WEBPACK FOOTER //
// ./src/main.js